import { useLocation } from 'react-router-dom'

/**
 * Locale-aware paths for the /es route tree.
 * `isSpanish` — true when the current URL lives under /es.
 * `lp(to)` — prefixes an internal path with /es when browsing the Spanish tree,
 *            so navigation stays in the visitor's language.
 */
export default function useLocalePath() {
  const { pathname } = useLocation()
  const isSpanish = pathname === '/es' || pathname.startsWith('/es/')
  const lp = (to) => (isSpanish ? (to === '/' ? '/es' : `/es${to}`) : to)
  return { isSpanish, lp }
}
